module.exports = __webpack_public_path__ + "media/images/videoGray-e6622caf10085891eb964186e715761f.svg";